import type { MailboxInfo } from "owa-client-types";
import type { CopilotOnboardingStatus } from "../services/types/serviceSettingTypes";
import copilotSettingsStore, { FetchState } from "../store/store";

/**
 * Returns the PersonalOS onboarding status passed through on the Copilot settings
 * response, but only when the response has actually been loaded (from the service
 * or the startup cache). Returns undefined when settings are not yet loaded or the
 * server did not send a status — callers should fall back to their own lookup in
 * those cases.
 */
export function getPersonalOSOnboardingStatusFromStore(mailboxInfo: MailboxInfo): CopilotOnboardingStatus | undefined {
    const store = copilotSettingsStore(mailboxInfo);
    if (store.fetchState !== FetchState.SUCCEEDED && store.fetchState !== FetchState.STARTUPCACHE) {
        return undefined;
    }
    return store.personalOSOnboardingStatus;
}
